/*
 * Copyright 2025 Intuition Robotics ltd
 */
import * as React from "react";
import {CSSProperties} from "react";
import {COLORS} from "@res/colors";
import {FONTS} from "@res/fonts";
import {composeMessage} from "../ui/patients/PatientTab";

type Props = {
    text: string
    textStyle?: CSSProperties
    enabled: boolean
    onClick: () => void
}


export const MessagePatientButton = (props: Props) => {
    const enabled = props.enabled;

    return <div
        className={'ll_h_c'}
        onMouseEnter={(event) => {
            event.currentTarget.style.border = `1px solid ${COLORS.primary_blue}`;
        }}
        onMouseLeave={(event) => {
            event.currentTarget.style.border = `1px solid ${COLORS.neutral_gray_1}`;
        }}
        onClick={() =>
            props.enabled && props.onClick()
        }
        style={{
            border: `1px solid ${COLORS.neutral_gray_1}`, // also add border to be in sync with other buttons
            cursor: enabled ? "pointer" : "default",
            opacity: enabled ? 1 : 0.8,
            minHeight: 40,
            minWidth: 120,
            borderRadius: 4,
            textAlign: "center",
            justifyContent: "space-between",
            padding: "10px 13px",
            boxSizing: "border-box"
        }}>

        <div style={{width: 20, height: 20}}>
            <img alt={'compose'} src={composeMessage} height={20} width={20}/>
        </div>
        <div>
            {FONTS.reg_16_secondary_dark(props.text, {...props.textStyle})}
        </div>

    </div>;

}
